import React from "react";
import { Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Spin, Card, Avatar } from "antd";
import { getInspectionByUserId } from "../../Inspection/services/inspectionsApi";
import { formatDate } from "../../../Components/Common/Format/FormatDate";
import { getDriverById } from "../services/driverApi";
import { CarOutlined } from "@ant-design/icons";

const ResumeDriver = () => {
  const { id } = useParams();
  const { data: user, isLoading: isLoadingUser, isError: isErrorUser, errorUserMsg } = useQuery(
    ["user", id],
    () => getDriverById(id),
    { enabled: !!id }
  );
  
  const { data: inspections, isLoading, isError, error } = useQuery(
    ["inspections", user?.id],
    () => getInspectionByUserId(user.id),
    { enabled: !!user?.id }
  );
  
  if (isLoadingUser || isLoading) {
    return <Spin size="large" />;
  }

  if (isErrorUser || isError) {
    return <div>Erreur: {errorUserMsg || error?.message}</div>;
  }

  const vehicle = user?.vehicle;
  const avatarImage = vehicle?.fileName
    ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${vehicle.fileName}`
    : null;

  return (
    <div className="container my-4">
      <Row className="mb-2">
        <Col xs={12} md={6}>
          <Card>
            <Row>
              <Col md={6}>Voiture assignée :</Col>
              <Col md={6}>
                <Avatar
                  src={avatarImage || <CarOutlined />}
                  alt="Vehicle Avatar"
                  style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "8px" }}
                />
                <span style={{ textDecoration: "underline" }}>
                  {vehicle ? vehicle.model : "Aucune voiture assignée"}
                </span>
              </Col>
            </Row>

            <Card title="Informations" loading={isLoadingUser}>
              <SpecificationItem label="Prénom et Nom" value={user?.name} />
              <hr className="hrLigne" />
              <SpecificationItem label="Email" value={user?.email} />
              <hr className="hrLigne" />
              <SpecificationItem label="Role" value={user?.role?.name} />
              <hr className="hrLigne" />
              <SpecificationItem label="Téléphone" value={user?.phone} />
              <hr className="hrLigne" />
              <SpecificationItem label="N° Permis" value={user?.licenseNumber} />
              <hr className="hrLigne" />
              <SpecificationItem label="N° Pièce d'identité" value={user?.cniNumber} />
              <hr className="hrLigne" />
              <SpecificationItem label="Adresse" value={user?.address} />
              <hr className="hrLigne" />
              <SpecificationItem label="Créé le" value={formatDate(user?.createdAt)} />
              <hr className="hrLigne" />
              <SpecificationItem label="Statut" value={user?.status} />
            </Card>
          </Card>
        </Col>

        <Col xs={12} md={6}>
          <Card title="Détails Inspections & Incidents" loading={isLoading}>
            <InspectionsSummary inspections={inspections} />
            <IncidentSummary incidents={inspections} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const SpecificationItem = ({ label, value }) => {
  let badgeColor = "";
  if (label === "Statut") {
    switch (value) {
      case "Actif":
        badgeColor = "#2FB550";
        break;
      case "Inactif":
        badgeColor = "#FF2D55";
        break;
      default:
        badgeColor = "#FF9500";
    }
  }

  return (
    <Row className="mb-2">
      <Col xs={6}>
        <div className="labelT">{label}</div>
      </Col>
      <Col xs={6}>
        <div className="labelV">{value || "Non disponible"}</div>
      </Col>
    </Row>
  );
};

const InspectionsSummary = ({ inspections }) => {
  const inspection = inspections?.filter(item => item.category !== "Incident");
  const treatedCount = inspection?.filter(ins => ins.status === "Traité").length;
  const pendingCount = inspection?.filter(ins => ins.status === "En attente").length;
  const archivedCount = inspection?.filter(ins => ins.status === "Archivé").length;

  return (
    <Row className="mb-3">
      <Col xs={12}>
        <h6>Inspections</h6>
      </Col>
      <Col md={4}>
        <SummaryCard label="Traités" count={treatedCount} />
      </Col>
      <Col md={4}>
        <SummaryCard label="En attente" count={pendingCount} />
      </Col>
      <Col md={4}>
        <SummaryCard label="Archivés" count={archivedCount} />
      </Col>
    </Row>
  );
};

const IncidentSummary = ({ incidents }) => {
  const incident = incidents?.filter(item => item.category === "Incident");
  const treatedCountIncident = incident?.filter(ins => ins.type === "Traité").length;
  const pendingCountIncident = incident?.filter(ins => ins.status === "En attente").length;
  const resolvedIncident = incident?.filter(ins => ins.status === "Résolues").length;

  return (
    <Row className="mb-3">
      <Col xs={12}>
        <h6>Incidents</h6>
      </Col>
      <Col md={4}>
        <SummaryCard label="Traités" count={treatedCountIncident || 0} />
      </Col>
      <Col md={4}>
        <SummaryCard label="En attente" count={pendingCountIncident} />
      </Col>
      <Col md={4}>
        <SummaryCard label="Résolus" count={resolvedIncident} />
      </Col>
    </Row>
  );
};

const SummaryCard = ({ label, count }) => (
  <Card body style={{ textAlign: "center", fontSize: "18px" }}>
    <p>{count || "0"}</p>
    <span>{label}</span>
  </Card>
);

export default ResumeDriver;
